module.exports = __webpack_public_path__ + "static/media/telegram.bb7c6576.svg";